import React, { useState } from 'react'
//MUI
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import AllInclusiveIcon from '@material-ui/icons/AllInclusive'
import CallMadeIcon from '@material-ui/icons/CallMade'
import CallReceivedIcon from '@material-ui/icons/CallReceived'
//Redux
import { changeDropdownOption } from '../../redux'
import { useDispatch, useSelector } from 'react-redux'
function RoleMenu() {
  const ROLE = ['Overview (Received / Sent)', 'Received (To sign)', 'Sent (To be signed)']
  const [anchorEl, setAnchorEl] = useState(null)
  const overview = useSelector((state) => state.overview)
  const dispatch = useDispatch()

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleOption = (e) => {
    dispatch(changeDropdownOption(e.target.value))
    setAnchorEl(null)
  }
  return (
    <>
      <div onClick={handleClick} className='menuIcon'>
        {overview.dropdownOption === 1 && <AllInclusiveIcon />}
        {overview.dropdownOption === 2 && <CallReceivedIcon />}
        {overview.dropdownOption === 3 && <CallMadeIcon />}
        <span className='role-name'> {ROLE[overview.dropdownOption - 1]}</span>
      </div>

      <Menu
        id='simple-menu'
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <MenuItem onClick={handleOption} selected={overview.dropdownOption === 1} value={1} style={{ whiteSpace: 'pre' }}>
          <AllInclusiveIcon className='noClick' /> {ROLE[0]}
        </MenuItem>
        <MenuItem onClick={handleOption} selected={overview.dropdownOption === 2} value={2} style={{ whiteSpace: 'pre' }}>
          <CallReceivedIcon className='noClick' /> {ROLE[1]}
        </MenuItem>
        <MenuItem onClick={handleOption} selected={overview.dropdownOption === 3} value={3} style={{ whiteSpace: 'pre' }}>
          <CallMadeIcon className='noClick' /> {ROLE[2]}
        </MenuItem>
      </Menu>
    </>
  )
}

export default RoleMenu
